import React, { useState, useEffect, useRef } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  Typography,
  Autocomplete,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  getTaxCard,
  getTaxCodeWithDuplicate,
  getTaxCodeByTaxCardId,
  getWHTCodeByTaxType,
  vendorTaxDetail,
} from "../../actions";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  intColumn,
  resizeColumn,
} from "react-datasheet-grid";
import "./style.css";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

function TaxTeamTable({
  formState,
  setFormState,
  invoice_Amount,
  invoicePayload,
  show,
  edit,
  isProceed,
}) {
  const tableData = {
    invoice_Id: invoicePayload?.Invoice_id || 0,
    category: "",
    purchaseType: "",
    supplierJurisdiction: "",
    supplierType: "",
    status: "",
    fillingStatus: "",
    goodsNature: "",
    taxType: "",
    taxCode: "",
    amount: invoice_Amount,

    // <<<<===earlier====>  //
    // taxId: 0,
    // invoice_Id: parseInt(invoicePayload?.Invoice_id) || 0,
    // taxType: "",
    // taxCode: "",
    // amount: invoice_Amount || "",
    // comments: "",
    // created_By: "",
    // created_On: new Date(),
    // updated_By: "",
    // updated_On: new Date(),
    // taxCardId: 0,

    // category: "",
    // purchaseType: "",
    // supplierJurisdiction: "",
    // supplierType: "",
    // status: "",
    // fillingStatus: "",
    // goodsNature: "",
  };
  const classes = useStyles();
  const [taxTableDropdownData, setTaxTableDropdownData] = useState({
    category: [],
    purchaseType: [],
    supplierJurisdiction: [],
    supplierType: [],
    status: [],
    fillingStatus: [],
    goodsNature: [],
    taxType: [],
    taxCode: [],
  });

  const [taxCardLoading, setTaxCardLoading] = useState(false);
  const [taxCardData, setTaxCardData] = useState([]);
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [taxCodeListLoading, setTaxCodeListLoading] = useState(true);
  const [taxErrorMsg, setTaxErrorMsg] = useState("");
  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      taxCard_List: [
        ...(formState.taxCard_List || []),
        formState.taxCard_List[formState.taxCard_List.length - 1],
      ],
    }));
  };

  const deleteInput = (index) => {
    const filteredData = formState?.taxCard_List?.filter((x, i) => i !== index);
    setFormState((formState) => ({
      ...formState,
      taxCard_List: filteredData,
    }));
    setTaxErrorMsg("");
  };

  const changeHandler = (e, index) => {
    const { name, value } = e.target;
    let tempArray = formState.taxCard_List;
    tempArray[index] = {
      ...formState.taxCard_List[index],
      [name]: value,
    };
    setFormState((formState) => ({
      ...formState,
      taxCard_List: tempArray,
    }));
  };

  useEffect(() => {
    getTaxCard(setTaxTableDropdownData, setTaxCardLoading, setTaxCardData);
    getTaxCodeWithDuplicate(setTaxCodeList, setTaxCodeListLoading);
    if (edit == "true") {
      vendorTaxDetail(
        setTaxTableDropdownData,
        setFormState,
        formState,
        invoicePayload?.Vendor_Code,
        invoicePayload?.Invoice_id,
        invoice_Amount,
        setTaxCardLoading
      );
    }
  }, []);

  const getBindingsOfTaxTable = (f, bindingNames, tempArray, index) => {
    for (let i = f?.id || 0; i < bindingNames.length; i++) {
      const element = bindingNames[i];
      const updated = tempArray[index];
      const filtered = taxCardData.filter((x) => {
        if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction &&
          updated?.supplierType &&
          updated?.status &&
          updated?.fillingStatus &&
          updated?.goodsNature
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status &&
            updated?.fillingStatus === x?.fillingStatus &&
            updated?.goodsNature === x?.goodsNature
          );
        } else if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction &&
          updated?.supplierType &&
          updated?.status &&
          updated?.fillingStatus
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status &&
            updated?.fillingStatus === x?.fillingStatus
          );
        } else if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction &&
          updated?.supplierType &&
          updated?.status
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status
          );
        } else if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction &&
          updated?.supplierType
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType
          );
        } else if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction
          );
        } else if (updated?.category && updated?.purchaseType) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType
          );
        } else if (updated?.category) {
          return updated?.category === x?.category;
        } else {
          return x;
        }
      });
      let binding = [
        ...new Map(filtered.map((item) => [item[element.name], item])).values(),
      ];
      setTaxTableDropdownData((taxTableDropdownData) => ({
        ...taxTableDropdownData,
        [element.name]: binding,
      }));

      let newValue = "";
      if (
        element?.name === "status" &&
        updated?.supplierType === "Unregistered"
      ) {
        //if statement, if supplierType is Unregistered and set value for status
        if (binding[0][element?.name] === "Active / Non-Active") {
          newValue = binding[0][element?.name];
        } else {
          newValue = "Non-Active";
        }
      } else if (
        element?.name === "fillingStatus" &&
        updated?.supplierType === "Unregistered"
      ) {
        // 2nd if statement, if supplierType is Unregistered and set value for fillingStatus
        newValue = "Non- Filer";
      } else {
        newValue = binding?.[0]?.[element?.name] || "";
      }

      tempArray[index] = {
        ...formState.taxCard_List[index],
        [element.name]:
          f !== null
            ? // newValue
              element?.name === "status" &&
              updated?.supplierType === "Unregistered" //if statement, if supplierType is Unregistered and set value for status.
              ? binding[0][element?.name] === "Active / Non-Active"
                ? binding[0][element?.name]
                : "Non-Active"
              : element?.name === "fillingStatus" &&
                updated?.supplierType === "Unregistered" // 2nd if statement, if supplierType is Unregistered and set value for fillingStatus.
              ? updated?.category === "Company"
                ? "Non-Filer"
                : "Non- Filer"
              : binding?.[0]?.[element?.name]
            : "",
        dropdowns: {
          ...formState.taxCard_List[index].dropdowns,
          [element.name]: binding,
        },
      };
    }
    return tempArray;
  };
  //
  //   useEffect(()=>{
  //     if( salesTaxCode && formState?.taxCard_List?.taxType ){
  //       autoCompleteChangeHandler(
  //         "taxType",
  //         formState?.taxCard_List?.taxType,
  //         ()=>{}
  //       )
  //     }

  //   },[])

  const autoCompleteChangeHandler = (
    name,
    newValue,
    index,
    nextBindingName
  ) => {
    let tempArray = formState.taxCard_List;
    tempArray[index] = {
      ...formState.taxCard_List[index],
      [name]:
        name === "taxType"
          ? newValue?.taxType
          : name === "taxCode"
          ? newValue?.taxCode
          : newValue?.[name],
    };
    if (name === "taxType") {
      getWHTCodeByTaxType(
        setTaxTableDropdownData,
        setFormState,
        formState,
        tempArray,
        index,
        newValue?.taxType,
        formState?.salesTaxCode
      );
    }

    setFormState((formState) => ({
      ...formState,
      taxCard_List: tempArray,
    }));

    if (
      name === "category" ||
      name === "purchaseType" ||
      name === "supplierJurisdiction" ||
      name === "supplierType" ||
      name === "status" ||
      name === "fillingStatus" ||
      name === "goodsNature"
    ) {
      tempArray[index] = {
        ...formState.taxCard_List[index],
        [name]: newValue?.[name],
        taxType: "",
        taxCode: "",
        // amount: tempArray[index].amount || invoice_Amount,
        purchaseType: name === "category" ? "" : tempArray[index].purchaseType,
        supplierJurisdiction:
          name === "category" || name === "purchaseType"
            ? ""
            : tempArray[index].supplierJurisdiction,
        supplierType:
          name === "category" ||
          name === "purchaseType" ||
          name === "supplierJurisdiction"
            ? ""
            : tempArray[index].supplierType,
        status:
          name === "category" ||
          name === "purchaseType" ||
          name === "supplierJurisdiction" ||
          name === "supplierType"
            ? ""
            : tempArray[index].status,
        fillingStatus:
          name === "category" ||
          name === "purchaseType" ||
          name === "supplierJurisdiction" ||
          name === "supplierType" ||
          name === "status"
            ? ""
            : tempArray[index].fillingStatus,
        goodsNature:
          name === "category" ||
          name === "purchaseType" ||
          name === "supplierJurisdiction" ||
          name === "supplierType" ||
          name === "status" ||
          name === "fillingStatus"
            ? ""
            : tempArray[index].goodsNature,
      };

      const bindingNames = [
        { id: 1, name: "purchaseType" },
        { id: 2, name: "supplierJurisdiction" },
        { id: 3, name: "supplierType" },
        { id: 4, name: "status" },
        { id: 5, name: "fillingStatus" },
        { id: 6, name: "goodsNature" },
      ];
      const f = bindingNames.find((x) => x.name === name);

      tempArray = getBindingsOfTaxTable(f, bindingNames, tempArray, index);

      // Block tax code (check)
      const _category = tempArray[index].category
        ? tempArray[index].category
        : "";
      const _purchaseType = tempArray[index].purchaseType
        ? tempArray[index].purchaseType
        : "";
      const _supplierJurisdiction = tempArray[index].supplierJurisdiction
        ? tempArray[index].supplierJurisdiction
        : "";
      const _supplierType = tempArray[index].supplierType
        ? tempArray[index].supplierType
        : "";
      const _status = tempArray[index].status ? tempArray[index].status : "";
      const _fillingStatus = tempArray[index].fillingStatus
        ? tempArray[index].fillingStatus
        : "";
      const _goodsNature = tempArray[index].goodsNature
        ? tempArray[index].goodsNature
        : "";
      const _d = taxCardData.filter(
        (i) =>
          (i.category === _category || _category === "") &&
          (i.purchaseType === _purchaseType || _purchaseType === "") &&
          (i.supplierJurisdiction === _supplierJurisdiction ||
            _supplierJurisdiction === "") &&
          (i.supplierType === _supplierType || _supplierType === "") &&
          (i.status === _status || _status === "") &&
          (i.fillingStatus === _fillingStatus || _fillingStatus === "") &&
          (i.goodsNature === _goodsNature || _goodsNature === "")
      );

      if (_d.length > 0) {
        var _t = taxCodeList.filter(
          (i) => i.TaxCardIds.split(",").indexOf(_d[0].id.toString()) > -1
        );

        // var _taxType = app.taxType_list.filter(i => app.taxCodes.filter(i => i.TaxCardIds != undefined && i.TaxCardIds != '').filter(i => i.TaxCardIds.split(',').filter(i => _d.map(j => j.Id.toString()).includes(i))).map(i => i.WH_TAX_TYPE).includes(i.substring(0,2)))
        var _taxType = formState.vendor_tax_detail.filter((i) =>
          _t.map((j) => j.WHTaxType).includes(i.Tax_Type)
        );
        if (_taxType.length > 0) {
          setTaxErrorMsg("");
        } else {
          setTaxErrorMsg("Tax Codes are not available with current selection.");
        }
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // <<<=====Block tax code (check)=====>>>

      const finded = taxCardData.find(
        (x) =>
          x.category === tempArray[index].category &&
          x.purchaseType === tempArray[index].purchaseType &&
          x.supplierJurisdiction === tempArray[index].supplierJurisdiction &&
          x.supplierType === tempArray[index].supplierType &&
          x.status === tempArray[index].status &&
          x.fillingStatus === tempArray[index].fillingStatus &&
          x.goodsNature === tempArray[index].goodsNature
      );
      setFormState((formState) => ({
        ...formState,
        taxCard_List: tempArray,
      }));
      getTaxCodeByTaxCardId(
        setTaxTableDropdownData,
        setFormState,
        formState,
        tempArray,
        index,
        finded?.id,
        invoicePayload?.Invoice_id,
        invoice_Amount
      );
    }
  };
  // if vender have already some tax detail.
  const getBindingsOfTaxTableForVendorTaxDetail = (
    bindingNames,
    tempArray,
    index
  ) => {
    for (let i = 0; i < bindingNames.length; i++) {
      const bindingName = bindingNames[i];
      const updated = tempArray[index];

      const filtered = taxCardData.filter((x) => {
        if (bindingName.name === "category") {
          return x;
        } else if (bindingName.name === "purchaseType") {
          return updated?.category === x?.category;
        } else if (bindingName.name === "supplierJurisdiction") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType
          );
        } else if (bindingName.name === "supplierType") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction
          );
        } else if (bindingName.name === "status") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType
          );
        } else if (bindingName.name === "fillingStatus") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status
          );
        } else if (bindingName.name === "goodsNature") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status &&
            updated?.fillingStatus === x?.fillingStatus
          );
        }
      });

      let binding = [
        ...new Map(
          filtered.map((item) => [item[bindingName.name], item])
        ).values(),
      ];
      setTaxTableDropdownData((taxTableDropdownData) => ({
        ...taxTableDropdownData,
        [bindingName.name]: binding,
      }));
      tempArray[index] = {
        ...formState.taxCard_List[index],
        // [bindingName.name]: binding[0][bindingName?.name],
        dropdowns: {
          ...formState.taxCard_List[index].dropdowns,
          [bindingName.name]: binding,
        },
      };
    }
    return tempArray;
  };

  const getBindingsOfTaxTypeAndWHTCode = (tempArray) => {
    for (let index = 0; index < formState.taxCard_List.length; index++) {
      const finded = taxCardData.find(
        (x) =>
          x.category === tempArray[index]?.category &&
          x.purchaseType === tempArray[index].purchaseType &&
          x.supplierJurisdiction === tempArray[index].supplierJurisdiction &&
          x.supplierType === tempArray[index].supplierType &&
          x.status === tempArray[index].status &&
          x.fillingStatus === tempArray[index].fillingStatus &&
          x.goodsNature === tempArray[index].goodsNature
      );
      getTaxCodeByTaxCardId(
        setTaxTableDropdownData,
        setFormState,
        formState,
        tempArray,
        index,
        finded?.id,
        invoicePayload?.Invoice_id,
        invoice_Amount
      );
    }
  };

  useEffect(() => {
    let tempArray = formState.taxCard_List;
    const bindingNames = [
      { id: 1, name: "category" },
      { id: 2, name: "purchaseType" },
      { id: 3, name: "supplierJurisdiction" },
      { id: 4, name: "supplierType" },
      { id: 5, name: "status" },
      { id: 6, name: "fillingStatus" },
      { id: 7, name: "goodsNature" },
    ];

    if (formState?.taxCard_ListCheck?.length === 0) {
      // const f = bindingNames.find((x) => x.name === name);
      const index = 0;
      tempArray[index] = tableData;
      tempArray = getBindingsOfTaxTable(null, bindingNames, tempArray, index);
      const finded = taxCardData.find(
        (x) =>
          x.category === tempArray[index].category &&
          x.purchaseType === tempArray[index].purchaseType &&
          x.supplierJurisdiction === tempArray[index].supplierJurisdiction &&
          x.supplierType === tempArray[index].supplierType &&
          x.status === tempArray[index].status &&
          x.fillingStatus === tempArray[index].fillingStatus &&
          x.goodsNature === tempArray[index].goodsNature
      );

      setFormState((formState) => ({
        ...formState,
        taxCard_List: tempArray,
      }));
      getTaxCodeByTaxCardId(
        setTaxTableDropdownData,
        setFormState,
        formState,
        tempArray,
        index,
        finded?.id,
        invoicePayload?.Invoice_id,
        invoice_Amount
      );
    } else if (formState?.taxCard_ListCheck?.length > 0) {
      for (let i = 0; i < formState?.taxCard_ListCheck?.length; i++) {
        tempArray = getBindingsOfTaxTableForVendorTaxDetail(
          bindingNames,
          tempArray,
          i
        );
      }
      setFormState((formState) => ({
        ...formState,
        taxCard_List: tempArray,
      }));
      getBindingsOfTaxTypeAndWHTCode(tempArray);
    }
  }, [formState?.taxCard_ListCheck]);
  const handleGridChange = (data, operation, rowKey) => {};

  const selectComponent = React.memo(
    ({ active, rowData, setRowData, focus, stopEditing, columnData }) => {
      const ref = useRef(null);

      //
      useEffect(() => {
        if (focus) {
          ref.current?.focus();
        } else {
          ref.current?.blur();
        }
      }, [focus]);

      return (
        <>
          {/*{() => ( */}

          <FormControl fullWidth>
            <Autocomplete
              id="selectedTaxCode"
              // options={item?.dropdowns?.category || []}
              options={columnData.choices}
              // options={taxTableDropdownData?.category}
              getOptionLabel={(option) => option?.label}
              size="small"
              // style={{ width: 200}}
              // value={taxTableDropdownSelected.category}
              //   value={{ category: item?.category || "" }}
              //   getOptionLabel={(option) =>
              //     (option !== "" && `${option?.category}`) || ""
              //   }
              //   // key={(option) => option?.category}
              loading={taxCardLoading}
              variant="standard"
              //   onChange={(event, newValue) => {
              //     autoCompleteChangeHandler(
              //       "category",
              //       newValue,
              //       index,
              //       "purchaseType"
              //     );
              //   }}
              disabled={edit == "false" || !edit ? true : false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  type="text"
                  name=""
                  variant="standard"
                  // required={isProceed}
                />
              )}
            />
          </FormControl>
        </>
      );
    }
  );
  const selectColumn = (options) => ({
    component: selectComponent,
    columnData: options,
    disableKeys: true,
    keepFocus: true,

    // copyValue: ({ rowData }) => rowData,
    // pasteValue: ({ value }) => value,
    // copyValue: ({ rowData }) => {
    //   const selectedChoice = options.choices.find(
    //     (choice) => choice.data === rowData
    //   );
    //   return selectedChoice ? selectedChoice.label : "";
    // },
    // pasteValue: ({ value }) => {
    //   const selectedChoice = options.choices.find(
    //     (choice) => choice.label === value
    //   );
    //   return selectedChoice ? selectedChoice.data : null;
    //
    // },
  });
  const columns = [
    {
      ...keyColumn(
        "category",
        selectColumn({
          choices: taxTableDropdownData?.category?.map((category, i) => ({
            data: category,
            value: `${category.category}`,
            label: `${category.category}`,
          })),
        })
      ),
      title: "Category",
      minWidth: 210,
    },
    {
      ...keyColumn(
        "purchaseType",
        selectColumn({
          choices: taxTableDropdownData?.purchaseType?.map(
            (purchaseType, i) => ({
              data: purchaseType,
              value: `${purchaseType.purchaseType}`,
              label: `${purchaseType.purchaseType}`,
            })
          ),
        })
      ),
      title: "Purchase Type",
      minWidth: 210,
    },
    {
      ...keyColumn(
        "supplierJurisdiction",
        selectColumn({
          choices: taxTableDropdownData?.supplierJurisdiction?.map(
            (supplierJurisdiction, i) => ({
              data: supplierJurisdiction,
              value: `${supplierJurisdiction.supplierJurisdiction}`,
              label: `${supplierJurisdiction.supplierJurisdiction}`,
            })
          ),
        })
      ),
      title: "Supplier Jurisdiction",
      minWidth: 210,
    },

    {
      ...keyColumn(
        "supplierType",
        selectColumn({
          choices: taxTableDropdownData?.supplierType?.map((item, i) => ({
            data: item,
            value: `${item.supplierType}`,
            label: `${item.supplierType}`,
          })),
        })
      ),
      title: "Supplier Type",
      // width: 150,
      minWidth: 160,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      ...keyColumn(
        "status",
        selectColumn({
          choices: taxTableDropdownData?.status?.map((item, i) => ({
            data: item,
            value: `${item.status}`,
            label: `${item.status}`,
          })),
        })
      ),
      title: "status",
      minWidth: 220,
      // disabled: ({ disabled }) => (disabled ? true : false),
      // disabled: true,

      // grow: 2,
    },
    {
      ...keyColumn("fillingStatus", textColumn),
      title: "Filling Status",
      minWidth: 160,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      ...keyColumn("goodsNature", textColumn),
      title: "goods Nature",

      // disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      ...keyColumn("taxtype", textColumn),
      title: "Tax Type",

      // disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      ...keyColumn("taxCode", textColumn),
      title: "WHT Code",

      // disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      ...keyColumn("amount", intColumn),
      title: "Amount",
      // width: 150,
      // disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
  ];
  return (
    <div>
      <Grid container>
        <h3>{taxErrorMsg ? taxErrorMsg : ""}</h3>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
          {taxTableDropdownData?.category?.length > 0 && (
            <DataSheetGrid
              style={{
                "--dsg-header-text-color": "#031C30",
              }}
              value={formState?.taxCard_List}
              // onChange={handleGridChange}
              columns={columns}
              //  lockRows={(disabled || formState.invoicePORef_List.length === 0) ? true: false}
              onChange={handleGridChange}

              // onActiveCellChange={(res) => {
              //
              //   setCellState(res?.cell?.colId);
              // }}

              // onDelete={handleDelete}
            />
          )}

          {!show && (
            <Box display="flex" justifyContent={"flex-end"} mt={2}>
              <Button color="secondary" variant="contained" onClick={addInput}>
                Add New Row
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default TaxTeamTable;
